import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';

import { params } from '@app/configurations';
import { FadeAnimation } from '@app/core/animations/fade.transition';
import { GlobalFiltersState } from '@app/core/store/states/global-filters/global-filters.state';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { map, Observable } from 'rxjs';
import { FilterMode, SelectorTranslationTexts } from '../../models/selector.model';
import { PgSelectorService } from '../../services/pg-selector.service';
import { BaseGlobalSelectorComponent } from '../base-global-selector/base-global-selector.component';

@Component({
  standalone: false,
  selector: 'adspt-pg-selector',
  templateUrl: './pg-selector.component.html',
  styleUrls: ['./pg-selector.component.scss'],
  animations: [FadeAnimation],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [PgSelectorService],
})
export class PgSelectorComponent extends BaseGlobalSelectorComponent {
  @Input() hideInactive = false;
  readonly PGparams = [params.GLOBAL_FILTER_PERFORMANCE_GROUP_ID, params.GLOBAL_FILTER_PERFORMANCE_GROUP_QUERY];

  heapInfo = {
    search: 'groups-global-tab-search:tab=pg',
    switch: 'pg-global-filter-switch',
    item: 'groups-global-tab-select:tab=pg',
    reset: 'groups-groups-reset-filter',
    apply: 'groups-groups-apply-filter',
  };
  translations$: Observable<SelectorTranslationTexts> = this.translate.get('global-filter.group-selector').pipe(
    map((values) => ({
      title: values['title-perf'],
      search: values['search-perf'],
      all: values['all-perf'],
      selected: values['selected-perf'],
      applyTooltip: values['apply-filters-tooltip'],
    })),
  );
  hasSrcQuery$ = this.store.select(GlobalFiltersState.hasPGQuery);
  hasDestQuery$ = this.store.select(GlobalFiltersState.hasDestPGQuery);

  onRefinerChange({ filters, query }, tab: FilterMode) {
    const func = tab === FilterMode.Source ? 'onSrcListScrolled$' : 'onDestListScrolled$';
    this.service[func].next(0);
    this.service[tab === FilterMode.Source ? 'srcSub$' : 'destSub$'].next({
      filters: filters,
      query: query,
      hideInactive: this.hideInactive,
    });
  }

  constructor(
    private store: Store,
    service: PgSelectorService,
    translate: TranslateService,
    cd: ChangeDetectorRef,
  ) {
    super(service, translate, cd);
  }
}
